import type { Clock } from "@riffbox/protocol";

/**
 * Media position the room should be at, given a server wall-clock time.
 * This is the authoritative target every player chases (PRD §5).
 *
 * Position never runs past the media; callers that know the media duration can
 * clamp the result, but the clock itself is duration-agnostic.
 */
export function computeTargetPosition(clock: Clock, serverNowMs: number): number {
  // Only "playing" advances with wall-clock; "paused" and "preparing" (the
  // readiness gate) both hold frozen at positionSec.
  if (clock.state !== "playing") return clock.positionSec;
  return clock.positionSec + (serverNowMs - clock.anchorServerMs) / 1000;
}
